import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Schools from "@/pages/Schools";
import Hotels from "@/pages/Hotels";
import Pricing from "@/pages/Pricing";
import Process from "@/pages/Process";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/admin/AuthContext";
import AdminLayout from "@/admin/AdminLayout";
import Login from "@/admin/Login";
import Dashboard from "@/admin/Dashboard";
import ProjectDetail from "@/admin/ProjectDetail";
import Payments from "@/admin/Payments";
import Templates from "@/admin/Templates";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public marketing site */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/schools" element={<Schools />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/process" element={<Process />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
          </Route>

          {/* Admin console */}
          <Route
            path="/admin/*"
            element={
              <AuthProvider>
                <Routes>
                  <Route path="login" element={<Login />} />
                  <Route element={<AdminLayout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="projects/:id" element={<ProjectDetail />} />
                    <Route path="payments" element={<Payments />} />
                    <Route path="templates" element={<Templates />} />
                  </Route>
                </Routes>
              </AuthProvider>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
